import { useEffect, useState } from "react";
import { fetchEpisodes, type MemoryEpisode } from "@/api/memory";

const AGENTS = ["all", "booking", "marketing", "publicist", "manager", "memory", "accounting", "podcast"];

export default function Episodes() {
  const [episodes, setEpisodes] = useState<MemoryEpisode[]>([]);
  const [agentFilter, setAgentFilter] = useState("all");
  const [loading, setLoading] = useState(false);

  const refresh = async () => {
    setLoading(true);
    const data = await fetchEpisodes(agentFilter === "all" ? undefined : agentFilter);
    setEpisodes(data);
    setLoading(false);
  };

  useEffect(() => {
    refresh();
  }, [agentFilter]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="aa-page-title text-3xl font-semibold">
            <span className="aa-gradient-text">Memory Episodes</span>
          </h1>
          <p className="text-sm text-muted-foreground">Browse episodic memory snapshots.</p>
        </div>
        <select
          value={agentFilter}
          onChange={(event) => setAgentFilter(event.target.value)}
          className="rounded border border-border bg-background/70 px-3 py-1 text-sm"
        >
          {AGENTS.map((name) => (
            <option key={name} value={name}>
              {name}
            </option>
          ))}
        </select>
      </div>
      <section className="aa-glass-card rounded-2xl p-4">
        {loading ? (
          <p className="text-sm text-muted-foreground">Loading episodes…</p>
        ) : episodes.length === 0 ? (
          <p className="text-sm text-muted-foreground">No episodes stored.</p>
        ) : (
          <ul className="space-y-3">
            {episodes.map((episode) => (
              <li key={episode.id} className="aa-glass-card rounded-xl p-3">
                <div className="flex items-center justify-between text-xs text-muted-foreground">
                  <span className="font-semibold text-foreground">{episode.agent}</span>
                  <span>{episode.timestamp ? new Date(episode.timestamp).toLocaleString() : ""}</span>
                </div>
                <div className="text-sm text-foreground/80 mt-1">{episode.summary}</div>
                <pre className="overflow-x-auto rounded bg-background/70 p-2 text-xs text-muted-foreground">
                  {JSON.stringify(episode.data ?? {}, null, 2)}
                </pre>
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
